module.exports = __webpack_public_path__ + "static/media/pickup.1a0e74de.svg";